import Vue from 'vue'
import dayjs from 'dayjs'
import 'dayjs/locale/th'
import buddhistEra from 'dayjs/plugin/buddhistEra'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)
dayjs.extend(buddhistEra)

Vue.filter('slashDateWithTime', (val) => dayjs(val).format('DD/MM/YYYY, HH:mm'))

Vue.prototype.$dayjs = dayjs

export default dayjs
